import { trackAddToCart } from '../lib/metaPixel'

// Stable Shopify "add to cart" permalink (variant id : quantity). Unlike the
// temporary /checkouts/cn/... session links, this never expires and reliably
// adds the product to the cart before checkout.
export const CHECKOUT_URL = 'https://controltotalhoy.com/cart/49857180238064:1'

export function goToCheckout() {
  // Fire the Meta Pixel AddToCart event the moment the user commits to buying,
  // before sending them to the Shopify checkout.
  trackAddToCart()

  // Open the checkout in a new tab so the current page (and the editor preview)
  // stays mounted instead of navigating away / "disconnecting".
  window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer')
}
